import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { withRouter } from '../../utils/hoc/withRouter';

class ContentManagment extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() { }

    render() {
        return (
            <div>ContentManagment Component </div>
        )
    }
}

const mapStateToProps = state => ({
    ContentManagmentState: state.ContentManagmentState
});
const mapDispatchToProps = {
    // getPosts: fetchPosts
}
ContentManagment.propTypes = {
    // getPosts: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ContentManagment));